export default "__VITE_ASSET__BfVAXNwZ__"